module.exports = __webpack_public_path__ + "img/fiat-smartrace-autoshow-02.9fca64db.jpg";